import React from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";
import { fromUnixTime, format } from "date-fns";

// mui
import { grey } from "@mui/material/colors";

const style = {
  text: css`
    color: ${grey[500]};
    font-size: 0.7rem;
  `,
};

type TimeStampProps = {
  msg: CometChat.BaseMessage;
};

const TimeStamp: React.FC<TimeStampProps> = (props) => {
  const { msg } = props;

  const sendAt = fromUnixTime(msg.getSentAt());
  const sendAtFormated = format(sendAt, "HH:mm");
  return <div css={style.text}>{sendAtFormated}</div>;
};

export default TimeStamp;
